var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.153 10.252.107.105-.19.292a.92.92 0 0 0 0 .702l-.14.056a.4.4 0 0 0 .07.115l.02.029.002.002.023.04.025.044q.029.053.083.111l8.93 9.09a1.033 1.033 0 0 0 1.477 0 1.07 1.07 0 0 0 0-1.495L4.405 12.06h14.11c.578 0 1.043-.477 1.043-1.059s-.465-1.059-1.044-1.059H4.404l7.156-7.284a1.07 1.07 0 0 0 0-1.496 1.03 1.03 0 0 0-1.477 0zm22.954-.311H21.93c-.578 0-1.043.477-1.043 1.06 0 .581.465 1.058 1.043 1.058h2.177c.578 0 1.043-.477 1.043-1.059s-.465-1.059-1.043-1.059Z",
    fill: "#FF5956",
    stroke: "#FF5956",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLeftArrow);
export default __webpack_public_path__ + "static/media/ic_left_arrow.a524afadda42f3bc00e02fd1b114bfc6.svg";
export { ForwardRef as ReactComponent };